import React, { useState } from "react";
import { Link } from "react-router-dom";
import { RenderSecure } from "../../util/script/RenderSecure";


const AdminDropdown = ({user, handleLogout}) => {
  const [isOpen, setIsOpen] = useState(false); // Track dropdown state

  // Toggle Dropdown Visibility
  const toggleDropdown = () => {
    setIsOpen((prevState) => !prevState);
  };

  return (
    <li className={`navbar-item dropdown header-admin ${isOpen ? "show" : ""}`}>
      <Link to="#" 
        className="navbar-nav-link dropdown-toggle" 
       
        role="button" 
        onClick={toggleDropdown} 
        aria-expanded={isOpen}
      >
        <div className="admin-title">
          <h5 className="item-title">{user.full_name}</h5>
          <span>{user.role_name}</span>
        </div>
        <div className="admin-img">
        <img src={process.env.PUBLIC_URL + "/assets/img/figure/user55.png"} alt="Admin"  style={{width:40, backgroundColor:"white"}}/>
        </div>
      </Link>

      {/* Dropdown Menu */}
      <div className={`dropdown-menu dropdown-menu-right ${isOpen ? "show" : ""}`}>
        <div className="item-header">
          <h6 className="item-title">{user.full_name}</h6>
        </div>
        <div className="item-content">
        <ul className="settings-list">
                  <RenderSecure code="ADMIN-VIEW"><li>
                    <Link to={'/settings'}>
                    <i className="fa fa-cog" />
                        Settings
                      </Link>
                    </li></RenderSecure>
                    <li>
                    <Link to={'/profile'}>
                    <i className="flaticon-user" />
                        My Profile
                      </Link>
                    </li>

                    <li>
                      <Link onClick={handleLogout}>
                        <i className="flaticon-turn-off" />
                        Log Out
                      </Link>
                    </li>
                  </ul>
        </div>
      </div>
    </li>
  );
};

export default AdminDropdown;
